import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPosts } from "../../features/posts/postsSlice";
import PostItem from "./PostItem";

export default function PostGrid() {

  const dispatch = useDispatch();
  const { posts } = useSelector(state => state.posts);
  const { isSaved, sort } = useSelector(state => state.sortFilter)

  useEffect(() => {
    dispatch(fetchPosts({sort,isSaved}))
  }, [dispatch,sort,isSaved])


  return (
    <main className="post-container" id="lws-postContainer">
      {posts?.length ?
        posts.map(post => (
          <PostItem post={post} key={post.id} />
        ))
        :
        <div>Posts Not Found</div>
      }
    </main>
  )
}